import { useMutation } from '@tanstack/react-query';
import { ConsentsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useConsentsControllerRevokeMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['consentsControllerRevoke', accessControlScope],
        mutationFn: async (args) => {
            const api = new ConsentsApi(accessControlConfig);
            return api.consentsControllerRevoke(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useConsentsControllerRevokeMutation.js.map